export interface IRedIconObject{
  key:string;
  path?:string;
  isSvg?:boolean;
}
export type IRedIcon = string  | IRedIconObject
